<template>
  <div>
    <p class="title is-5">HD-Races client</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">API host</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="hdRacesSettings.client.apiHost" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">HD-Races client ID</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="hdRacesSettings.client.clientId" class="input oc-input" type="number" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">API key</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="hdRacesSettings.client.apiKey" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Widget url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="hdRacesSettings.client.widgetUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">Lobby url</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="hdRacesSettings.client.lobbyUrl" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <p class="title is-5">HD-Races server</p>
    <div class="field is-horizontal">
      <div class="field-label is-normal">
        <label class="label">API key</label>
      </div>
      <div class="field-body">
        <div class="field">
          <p class="control">
            <input v-model="hdRacesSettings.server.apiKey" class="input oc-input" type="text" />
          </p>
        </div>
      </div>
    </div>

    <div class="field is-horizontal">
      <div class="field-label">
      </div>
      <div class="field-body">
        <div class="field is-grouped">
          <div class="control">
            <button @click="save" class="button is-primary">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import hdracesService from '../../../../services/hdraces.service';

  export default {
    name: 'client-settings-hdraces',
    data() {
      return {
        hdRacesSettings: {
          server: {},
          client: {}
        }
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    async mounted() {
      this.hdRacesSettings = await hdracesService.getSettingsByClient(this.clientId);
    },
    methods: {
      async save() {
        await hdracesService.save(this.clientId, this.hdRacesSettings);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/settings/hdraces.vue